import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { ReplenishmentRaise, ReplenishmentRaiseResult } from '../../../models/stock';
import { TransferAvailableStock } from '../../../../sales/transfers/models';
import { TmsWebBaseService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ReplenishmentService extends TmsWebBaseService {
  constructor() {
    super('Replenishment');
  }

  // Where an ad-hoc raise (nothing ticked on the screen) can pick from: warehouses holding
  // free stock, other than the one being topped up.
  sourceWarehouses(destinationWarehouseId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/SourceWarehouses/${destinationWarehouseId}`);
  }

  // The judgement pull: stock hovering above its reorder level that the warehouse knows it
  // will need before the next pallet.
  pull(productId: string, warehouseId: string, quantity: number, reason: string): Observable<void> {
    return this.httpService.post<void>(`${this.apiUrl}/Pull`, { productId, warehouseId, quantity, reason });
  }

  // Raise a transfer pick list from ticked replenishment lines, with the chosen rolls recorded
  // as the plan for each line. The API refuses a mixed-source batch or a roll that is not free
  // at the source, and its message is the one to show.
  raise(model: ReplenishmentRaise): Observable<ReplenishmentRaiseResult> {
    return this.httpService.post<ReplenishmentRaiseResult>(`${this.apiUrl}/Raise`, model);
  }

  // Free rolls of these products at the source warehouse - what the raise modal offers.
  availableStock(productIds: string[], sourceWarehouseId: string): Observable<TransferAvailableStock[]> {
    return this.httpService.post<TransferAvailableStock[]>(`${this.apiUrl}/AvailableStock`, {
      productIds,
      sourceWarehouseId,
    });
  }

  // Reconciliation sweep - re-runs the recompute over everything with levels set.
  recalculateAll(): Observable<number> {
    return this.httpService.post<number>(`${this.apiUrl}/RecalculateAll`, {});
  }
}
